export default {
  data: function () {
    return {
      steps: [{
          ID: 1,
          Descrizione: this.$Jed.firstUpperTranslate('pick %1$s', null, {
            key: 'customer'
          }),
          Componente: 'SelezionaCliente'
        },
        {
          ID: 1.5,
          Descrizione: this.$Jed.firstUpperTranslate('pick %1$s', null, {
            key: 'index'
          }),
          Componente: 'PreSelezione'
        },
        {
          ID: 2,
          Descrizione: this.$Jed.firstUpperTranslate('product identify', null),
          Componente: 'IdentificazioneProdotto'
        },
        {
          ID: 3,
          Descrizione: this.$Jed.firstUpperTranslate('product registration', null),
          Componente: 'RegistrazioneProdotto'
        },
        {
          ID: 4,
          Descrizione: this.$Jed.firstUpperTranslate('product menu', null),
          Componente: 'MenuProdotto'
        },
        {
          ID: 5,
          Descrizione: this.$Jed.firstUpperTranslate('pick %1$s', null, {
            key: 'index'
          }),
          Componente: 'SelezioneCatalogo'
        },
        {
          ID: 6,
          Descrizione: this.$Jed.firstUpperTranslate('pick %1$s', null, {
            key: 'model'
          }),
          Componente: 'SelezioneModello'
        },
        {
          ID: 7,
          Descrizione: this.$Jed.firstUpperTranslate('compatibility settings', null),
          Componente: 'ImpostazioneCompatibilità'
        }
      ],
      visibles: []
    }
  },
  mounted: function () {
    this.visibles = this.initVisibles();
  },
  methods: {
    initVisibles: function () {
      var r = [];
      if (this.$Configs.idAgente != null && this.$Configs.idAgente != 'null') {
        r.push(1);
      }
      if(!this.$Behaviors.loadFirstCatalog && this.$Behaviors.requestUpdateReference)r.push(1.5); //Se loadFirstCatalog è true non mostro PreSelezione e carico subito il catalogo

      if ((this.$Configs.catalogs && this.$Configs.catalogs.length > 0) && !this.$Behaviors.loadFirstCatalog) {
        if (this.$Behaviors.requestUpdateReference &&
          this.$Behaviors.machineIdMustExists &&
          this.$Behaviors.updatesReference == 'serial') {
          r.push(2);
          r.push(4);
          return r;
        }
      }
      r.push(5);
      // se l'inserimento compatibilità (validità) è abilitato, obbligatorio e per matricola, la selezione modello non viene proposta, in quanto in ogni caso caricherò la matricola selezionata
      if (this.$Behaviors.chooseRootNode && !(!this.$Behaviors.machineIdMustExists && this.$Behaviors.requestUpdateReference && this.$Behaviors.updatesReference == 'serial')) {
        r.push(6);
      }
      if (!this.$Behaviors.machineIdMustExists && this.$Behaviors.updatesReference != 'serial' && this.$Behaviors.requestUpdateReference) { 
        r.push(7);
      }
      return r;
    },
    secondSlice: function () {
      this.visibles = this.visibles.filter(function (id) {
        return id < 2;
      })
      this.visibles.push(5);
      if (this.$Behaviors.chooseRootNode && !(!this.$Behaviors.machineIdMustExists && this.$Behaviors.requestUpdateReference && this.$Behaviors.updatesReference == 'serial')) {
        this.visibles.push(6);
      }
      if (!this.$Behaviors.machineIdMustExists && this.$Behaviors.updatesReference != 'serial' && this.$Behaviors.requestUpdateReference) {
        this.visibles.push(7);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/loader/steps/step_structure_mixin.js